/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TenantOrgCapabilitiesDeployments } from './tenantOrgCapabilitiesDeployments';
import { TenantOrgCapabilitiesSddcManagement } from './tenantOrgCapabilitiesSddcManagement';
import { TenantOrgCapabilitiesDpx } from './tenantOrgCapabilitiesDpx';
import { TenantOrgCapabilitiesGlobalAccess } from './tenantOrgCapabilitiesGlobalAccess';
import { TenantOrgCapabilitiesRollout } from './tenantOrgCapabilitiesRollout';
import { TenantOrgCapabilitiesSubscriptions } from './tenantOrgCapabilitiesSubscriptions';
import { TenantOrgCapabilitiesResource } from './tenantOrgCapabilitiesResource';


export interface TenantOrgCapabilitiesVcdr { 
    deployments?: TenantOrgCapabilitiesDeployments;
    dpx?: TenantOrgCapabilitiesDpx;
    global_access?: TenantOrgCapabilitiesGlobalAccess;
    resource?: TenantOrgCapabilitiesResource;
    subscriptions?: TenantOrgCapabilitiesSubscriptions;
    sddc_management?: TenantOrgCapabilitiesSddcManagement;
    rollouts?: TenantOrgCapabilitiesRollout;
}

